import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icons/download-black.svg'
import _imports_1 from '@/assets/img/icons/add-participant.svg'
import _imports_2 from '@/assets/img/icons/add-user-black.svg'
import _imports_3 from '@/assets/img/icons/download-gray.svg'
import _imports_4 from '@/assets/img/icons/delete-gray.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-1cff32ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-between items-center mb-8 mt-4" }
const _hoisted_3 = { class: "flex w-2/3" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900 mb-2" }
const _hoisted_6 = { class: "text-sm leading-6 text-gray-400 mb-2" }
const _hoisted_7 = { class: "flex gap-3 items-start" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xl leading-7 font-semibold tracking-wider text-blue-900 mb-2" }, " List Peserta ", -1))
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col items-center justify-center my-10 gap-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-32 h-32 mb-4"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-400" }, "Anda belum menambahkan peserta", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "ml-1"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_4 }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_table_lite = _resolveComponent("table-lite")!
  const _component_delete_test_participant_modal = _resolveComponent("delete-test-participant-modal")!

  return (Object.keys(_ctx.state.testDetail).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_back_button),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.state.testDetail?.bundle?.image,
              alt: `${_ctx.state.testDetail.bundle.name} image`,
              class: "w-20 h-20 mx-4"
            }, null, 8, _hoisted_4),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.state.testDetail.bundle.name), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.state.testDetail.bundle.description), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.downloadReport && _ctx.downloadReport(...args))),
              class: "px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3"
            }, [
              _hoisted_8,
              _createTextVNode(" Download Excel ")
            ])
          ])
        ]),
        _hoisted_9,
        (!_ctx.table.isLoading && !_ctx.table.rows.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              (_openBlock(), _createBlock(_resolveDynamicComponent('router-link'), {
                tag: "button",
                to: `/admin/project/${_ctx.$route.params.projectId}/invite`,
                class: "px-4 py-2 bg-yellow-400 border-1 border-yellow-400 rounded text-black leading-6 text-sm font-semibold flex items-center gap-3"
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _createTextVNode(" Tambah Peserta ")
                ]),
                _: 1
              }, 8, ["to"]))
            ]))
          : (_openBlock(), _createBlock(_component_table_lite, {
              key: 1,
              "is-slot-mode": true,
              "is-loading": _ctx.table.isLoading,
              columns: _ctx.table.columns,
              rows: _ctx.table.rows,
              total: _ctx.table.totalRecordCount,
              sortable: _ctx.table.sortable,
              onDoSearch: _ctx.doSearch,
              onIsFinished: _ctx.tableLoadingFinish
            }, {
              result: _withCtx((data) => [
                _createTextVNode(_toDisplayString(data.value.result || "-"), 1)
              ]),
              action: _withCtx((data) => [
                (data.value.result)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.downloadResult(data.value.id))
                    }, _hoisted_16, 8, _hoisted_14))
                  : _createCommentVNode("", true),
                (data.value.status === 'Unopened')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.actionDelete(data.value.id))
                    }, _hoisted_19, 8, _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["is-loading", "columns", "rows", "total", "sortable", "onDoSearch", "onIsFinished"])),
        _createVNode(_component_delete_test_participant_modal, {
          ref: "showDeleteModal",
          onOnSuccess: _ctx.doSearch
        }, null, 8, ["onOnSuccess"])
      ]))
    : _createCommentVNode("", true)
}